import customerServiceMessages from '../../../../messages/admin-console-messages/customer-service.messages';
import commonErrorMessages from '../../../../messages/common-messages/common-error.messages';
import { ErrorMessages } from '../../../../model/error';
import {
  CustomerServiceSearchFilters,
  SearchError
} from './customer-service-types';

export const verifySearchFilterFields = (
  filter: CustomerServiceSearchFilters
): SearchError | undefined => {
  let error: SearchError;
  const values = Object.values(filter) as string[];
  const checkNotExist = (value: string) => !value;
  const checkMinLength = (value: string) => !!value && value.length < 3;

  if (values.every(checkNotExist)) {
    return 'FILL_AT_LEAST_ONE_FIELD';
  } else if (values?.some(checkMinLength)) {
    return 'INVALID_FORMAT';
  }

  return error;
};

export const messagesForSearchError = (error: SearchError): ErrorMessages => {
  switch (error) {
    case 'FILL_AT_LEAST_ONE_FIELD':
      return {
        title: commonErrorMessages.errorTitleDefault,
        description: commonErrorMessages.errorFillAtLeastOneField,
      };
    case 'INVALID_FORMAT':
      return {
        title: commonErrorMessages.errorTitleDefault,
        description: customerServiceMessages.errorInvalidFieldFormat,
      };
    default:
      return {
        title: commonErrorMessages.errorTitleDefault,
        description: commonErrorMessages.errorDescriptionDefault,
      };
  }
};

export const messagesForCustomerServiceGenericError = (): ErrorMessages => {
  return {
    title: commonErrorMessages.errorTitleDefault,
    description: commonErrorMessages.errorDescriptionDefault,
  };
};

export const messagesForCustomerServiceNotMigratedUserError = (): ErrorMessages => {
  return {
    title: commonErrorMessages.errorTitleDefault,
    description: customerServiceMessages.errorNotMigratedUser,
  };
};

export const mapAdminConsoleDocumentKeyToOrdinamentoUtenti = {
  codiceCliente: 'CODICE_UTENTE',
  intestatario: 'NOME',
  figuraAccessoria: 'RAGIONE_SOCIALE',
  dataAttivazioneServizio: 'DATA_ATTIVAZIONE_SERVIZIO',
  stato: 'STATO',
  email: 'EMAIL',
  telefono: 'TELEFONO',
};
